module.exports = __webpack_public_path__ + "img/top_bg.60609a0c.jpg";